export default (store) => ({
  path : '/orders',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'OrderSearch' */
      './components/OrderSearch'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
